import React from 'react';
import { JourneyStrip } from './JourneyStrip';
import { MAIN_MOCKUP } from '../data/breakFreeContent';
export function SystemRevealSection() {
  return <section className="w-full border-y border-champagne/20 bg-black py-12 sm:py-16" aria-labelledby="reveal-title" data-id="element-156" data-mp="1yxq48ko7caxw">
      <div className="mx-auto max-w-5xl px-5 text-center" data-id="element-157" data-mp="1pyw44kbnx2fl">
        <p className="text-[11px] font-semibold uppercase tracking-[0.32em] text-champagne" data-id="element-158" data-mp="1q18sbf80k913">
          Break Free™
        </p>
        <h2 id="reveal-title" className="mt-3 font-display text-[1.7rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.5rem]" data-id="element-159" data-mp="1g0ygnz1mn9o1">
          The complete 6-volume system
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-[14px] leading-snug text-body sm:text-[16px]" data-id="element-160" data-mp="177v5jxegf8wk">
          6 Volumes + 6 Exclusive Bonuses — One complete path from confusion to
          independence.
        </p>

        <div className="mt-6 border-y border-charcoal-600 py-4" data-id="element-161" data-mp="x9fetvjca1nl">
          <JourneyStrip data-id="element-162" data-mp="32iavl02b7m2t" />
        </div>

        <img src={MAIN_MOCKUP} alt="The complete BREAK FREE™ system — six volumes and six exclusive bonuses" className="mx-auto mt-8 w-full max-w-sm sm:max-w-md" width={1080} height={1350} data-id="element-163" data-mp="32h9fgh6fs9e8" />
      </div>
    </section>;
}